import { makeStyles } from "@material-ui/core/styles";


export const useStyles = makeStyles(theme => ({
    arrow: {
        color: theme.palette.grey[700],
    },
    timeline: {
        width: "100%",
        display: "flex",
        justifyContent: "space-around",
        alignItems: "center",
        userSelect: "none",
        position: "relative",
        cursor: "pointer",
    },
    tickContainer: {
        cursor: "ew-resize",
        overflow: "hidden",
        position: "relative",
        height: 30,
        width: "100%",
    },
    tick: {
        position: "absolute",
        top: 0,
        "& div": {
            position: "absolute",
            top: 16,
            whiteSpace: "nowrap",
            transform: "translateX(-50%)",
            fontSize: 12,
            fontWeight: "bold",
            color: theme.palette.grey[700],
        },
    },
    tickMajor: {
        borderLeft: `1px solid ${theme.palette.grey[700]}`,
        height: 15,
    },
    tickMinor: {
        top: 2,
        borderLeft: `1px solid ${theme.palette.grey[300]}`,
        height: 12,
    },
    triangle: {
        borderTop: `10px solid ${theme.palette.grey[700]}`,
        borderLeft: "8px solid transparent",
        borderRight: "8px solid transparent",
        position: "absolute",
        bottom: 40,
    },
}));
